import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { API } from "../lib/content";

/**
 * useContentRedirect — when a detail page 404s, ask the backend whether
 * the entry moved to another content type (recorded by change-type) and
 * follow the redirect transparently. Returns `pending` while checking so
 * callers can delay their own fallback navigation.
 */
export default function useContentRedirect(active) {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const [pending, setPending] = useState(false);

    useEffect(() => {
        if (!active) return undefined;
        let cancelled = false;
        setPending(true);
        axios
            .get(`${API}/content-redirect`, { params: { path: pathname } })
            .then((r) => {
                if (!cancelled && r.data?.to && r.data.to !== pathname) {
                    navigate(r.data.to, { replace: true });
                }
            })
            .catch(() => {})
            .finally(() => { if (!cancelled) setPending(false); });
        return () => { cancelled = true; };
    }, [active, pathname, navigate]);

    return pending;
}
